// extracted by mini-css-extract-plugin
export default {"Badge":"BetStatusBadge_Badge__J4QtX","Label":"BetStatusBadge_Label__TkTc+"};